import React, { useEffect, useState } from "react";
import { GoArrowLeft } from "react-icons/go";
import ClipLoader from "react-spinners/ClipLoader";
import Register from "./Register";
import { useLocation, useNavigate } from "react-router-dom";
import { API } from "../constants/api";
import useAuthAxios from "../utils/baseAxios";
import { useCookies, Cookies } from "react-cookie";
import { useMutation } from "@tanstack/react-query";
import { toast } from "react-hot-toast";
import { errorMessage } from "../utils/errorMessage";
import OtpPin from "./OtpPin";

const VerifyMail = () => {
  const navigate = useNavigate();
  const [sendOtp, setSendOtp] = useState<boolean>(false);
  const [minutes, setMinutes] = useState<number>(0);
  const [seconds, setSeconds] = useState<number>(59);
  const [otp, setOtp] = useState<string>("");
  const location = useLocation();
  const { state } = location;
  const info = location?.state;
  const { from } = state || {};
  const axiosInstance = useAuthAxios();
  const [, setCookie, removeCookie] = useCookies(["request-otp"]);

  const handleVerify = async (data: any) => {
    const response = await axiosInstance.post(API.verifyEmail, data);
    return response.data;
  };
  const completeVerify = useMutation({
    mutationFn: handleVerify,
    onSuccess: (r) => {
      removeCookie("request-otp");
      // console.log(r);
      toast.success(r.message);
      setTimeout(() => {
        navigate("/dashboard");
      }, 2000);
    },
    onError: (error: any) => {
      toast.error(
        errorMessage((error?.data as any)?.message || String(error?.data))
      );
    },
  });
  useEffect(() => {
    const interval = setInterval(() => {
      if (seconds === 0) {
        if (minutes === 0) {
          clearInterval(interval);
        } else {
          setSeconds(59);
          setMinutes(minutes - 1);
        }
      } else {
        setSeconds(seconds - 1);
      }
    }, 1000);
    return () => {
      clearInterval(interval);
    };
  }, [seconds, minutes]);

  useEffect(() => {
    if (seconds > 0 || minutes > 0) {
      setSendOtp(true);
    } else {
      setSendOtp(false);
    }
  }, [seconds, minutes]);

  const resendOtp = () => {
    axiosInstance
      .post(API.requestOTP, {
        purpose: "email-verification",
      })
      .then((r: any) => {})
      .catch((e: any) => {
        console.log(e.response.data.message);
      });

    setMinutes(0);
    setSeconds(59);
  };

  useEffect(() => {
    if (from) {
      const cookies = new Cookies();
      const newCookie = cookies.get("request-otp");
      if (!newCookie) {
        setCookie("request-otp", "true");
        axiosInstance
          .post(API.requestOTP, {
            purpose: "email-verification",
          })
          .then((r: any) => {})
          .catch((e: any) => {
            console.log(e.response.data.message);
          });
      }
    }
  }, [from]);
  useEffect(() => {
    window.addEventListener("beforeunload", () => {
      removeCookie("request-otp");
    });
  }, []);

  const handleSubmit = () => {
    const data = {
      otp: otp,
    };
    completeVerify.mutate(data);
  };

  return (
    <div className="w-full mds:w-4/5 md:w-3/5 xxxl:w-[50%] px-6 lgss:px-0 pt-28 pb-20 lgss:pt-16 font-manrope h-full mx-auto flex-col justify-between  items-center  flex">
      <div className="flex flex-col justify-center  items-center   w-full">
        <div className="flex justify-start items-start w-full px-4 lgss:px-8">
          <GoArrowLeft
            onClick={() => {
              navigate("/signup");
            }}
            className="text-[#13181B] dark:text-gray-300 cursor-pointer text-[20px]"
          />
        </div>

        <h2 className="text-text_black w-full px-5 lgss:px-0 lgss:w-1/2 xxxl:w-2/5 dark:text-gray-200  font-sora text-2xl text-center font-bold mt-16 lgss:mt-24 lgss:pt-0 ">
          Verify Email
        </h2>
        <h4 className="font-manrope w-full px-5 lgss:px-0 lgss:w-1/2 text-center xxxl:w-2/5 dark:text-gray-200 text-text_black font-medium text-sm pt-6">
          Enter the 6-digit verification code sent to {info?.email}.
        </h4>
        <form className="mt-6 w-full  lgss:px-0 lgss:w-1/2 xxxl:w-2/5 ">
          <OtpPin otp={otp} setOtp={setOtp} input={6} />
          <div className="flex justify-center mt-4 items-center">
            {seconds > 0 || minutes > 0 ? (
              <p className="text-paragraph dark:text-white  font-bold text-[12px]">
                Time Remaining:{" "}
                <span className="text-secondary_button">
                  {minutes < 10 ? `0${minutes}` : minutes}:{" "}
                  {seconds < 10 ? `0${seconds}` : seconds}
                </span>
              </p>
            ) : (
              <p className="font-bold  text-paragraph dark:text-white text-[12px]">
                Didn't recieve code?
              </p>
            )}
            {!sendOtp && (
              <button
                onClick={(e) => {
                  e.preventDefault();
                  resendOtp();
                }}
                className="text-secondary_button text-[12px] flex justify-center items-center ml-2 font-bold"
              >
                Resend OTP
              </button>
            )}
          </div>
          <h4 className="text-[12px] mt-8  text-[#869AA9] font-bold">
            *If you don't get a mail in your inbox, kindly check your spam or
            promotions tab*
          </h4>
        </form>
      </div>
      <div className="w-full mds:w-[90%] lgss:w-1/2 xxxl:w-2/5 flex flex-col justify-center items-center">
        <button
          onClick={handleSubmit}
          disabled={completeVerify.isPending}
          className="w-full  h-[52px] flex justify-center items-center font-manrope font-medium rounded-xl text-white bg-secondary_button mt-8 lgss:mt-8"
        >
          {completeVerify.isPending ? (
            <ClipLoader color="#FFFFFF" size={30} />
          ) : (
            "Verify it's you"
          )}
        </button>
      </div>
    </div>
  );
};

const VerifyMailPage = () => (
  <div className="lgss:flex lgss:flex-row h-screen dark:bg-[#13181B]">
    <Register />
    <VerifyMail />
  </div>
);

export default VerifyMailPage;
